export var ButtonGroupDirection;
(function (ButtonGroupDirection) {
    ButtonGroupDirection["COLUMN"] = "Column";
    ButtonGroupDirection["ROW"] = "Row";
})(ButtonGroupDirection || (ButtonGroupDirection = {}));
